import { defineStore } from "pinia";
import { computed, readonly, ref } from "vue";

/**
 * Which pool the editor modal is open on, for every page that can open one.
 *
 * A pool is reached from the dashboard's forward sales card, the deal page, the volume picker and
 * `/admin/forwards`; each of those pages renders one `PoolEditorModalHost` driven by this store, and
 * anything on them that links to a pool calls `open`, rather than every link threading an event back
 * up to the page. The host
 * tells its page when a session wrote something.
 */
export const usePoolEditorLauncher = defineStore(
  "forwards2PoolEditorLauncher",
  () => {
    /** The open pool's id, `null` for a new pool, `undefined` while the editor is closed. */
    const poolId = ref<number | null | undefined>(undefined);

    const isOpen = computed(() => poolId.value !== undefined);

    const open = (id: number | null) => {
      poolId.value = id;
    };

    const close = () => {
      poolId.value = undefined;
    };

    return {
      poolId: readonly(poolId),
      isOpen,
      open,
      close,
    };
  }
);
